import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
  isAuth: boolean;
}

const initialState: AuthState = {
  isAuth: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, { payload }) => {
      return {
        isAuth: payload,
      };
    },
  },
});

export const { setAuth } = authSlice.actions;

export const getAuth = (state: { auth: AuthState }) => state.auth;

export const { reducer: authReducer } = authSlice;
